
































































































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		items: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		height: {
			type: Number,
			default: 330
		},
		iconaucun: {
			type: String,
			default: ''
		},
		messageerreuraucun: {
			type: String,
			default: ''
		},
		moisgrossesse: {
			type: Number,
			default: 1
		}
	},
	data: function() {
		return {
			isDisplayAfficherMoins: false,
			isDisplayAfficherPlus: true,
			maxHeight: this.height + 'px',
			minHeight: this.height + 'px'
		};
	},
	watch: {
		moisgrossesse: function(newVal, oldVal) {
			this.maxHeight = this.height + 'px';
			this.minHeight = this.height + 'px';
		}
	},
	mounted() {
		this.afficherBoutonPlusOuMoins();
	},
	updated() {
		this.updatedBoutonPlusOuMoins();
	},
	created() {
		window.addEventListener('resize', this.afficherBoutonPlusOuMoins);
	},
	methods: {
		afficherMoins: function() {
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.maxHeight = this.height + 'px';
		},
		afficherPlus: function() {
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.maxHeight = 'inherit';
		},
		updatedBoutonPlusOuMoins: function() {
			if (window.innerWidth > 760) {
				if (this.height >= this.$el.scrollHeight) {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
					this.maxHeight = this.height + 'px';
				} else {
					if (this.maxHeight == 'inherit') {
						this.isDisplayAfficherMoins= true;
						this.isDisplayAfficherPlus= false;
					} else {
						this.isDisplayAfficherMoins= false;
						this.isDisplayAfficherPlus= true;
					}
				}
			}
		},
		afficherBoutonPlusOuMoins: function() {
			if (window.innerWidth < 760) {
				this.minHeight = 'inherit';
				this.maxHeight = 'inherit';
				this.isDisplayAfficherMoins= false;
				this.isDisplayAfficherPlus= false;
			} else {
				this.minHeight = this.height + 'px';
				this.maxHeight = this.height + 'px';
				if (this.height >= this.$el.scrollHeight) {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
				} else {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= true;
				}
			}
		}
	}
});

@Component
export default class VCardTemplate extends Props {
}
